// extracted by mini-css-extract-plugin
module.exports = {"sitePage":"SitePage_sitePage__1WWF6","sidebar":"SitePage_sidebar__2cUY-","main":"SitePage_main__2o5U3"};